/** @format */

import axios from 'axios'
import { _processRegion, interfaceMessage } from './common'
import { _$ } from 'kpc-react'
import { v4 as uuidv4 } from 'uuid'
import _ from 'lodash'
import { IRresponseConfig, IAxiosRequestConfig } from './interface'
import { Message } from 'kpc-react'

const hideErrorMessageUrl = [
  '/monitor/?Action=ListNCEClusters&Version=2024-01-01',
  '/monitor/?Action=ListClusters&Version=2022-01-01'
]

const codeMessage = {
  200: _$('服务器成功返回请求的数据。'),
  201: _$('新建或修改数据成功。'),
  202: _$('一个请求已经进入后台排队（异步任务）。'),
  204: _$('删除数据成功。'),
  400: _$('发出的请求有错误，服务器没有进行新建或修改数据的操作。'),
  401: _$('用户没有权限（令牌、用户名、密码错误）。'),
  403: _$('用户得到授权，但是访问是被禁止的。'),
  404: _$('发出的请求针对的是不存在的记录，服务器没有进行操作。'),
  406: _$('请求的格式不可得。'),
  410: _$('请求的资源被永久删除，且不会再得到的。'),
  422: _$('当创建一个对象时，发生一个验证错误。'),
  500: _$('服务器发生错误，请检查服务器。'),
  502: _$('网关错误。'),
  503: _$('服务不可用，服务器暂时过载或维护。'),
  504: _$('网关超时。')
}

// const chosedRegion =
//   process.env.NODE_ENV === 'development' ? 'cn-shanghai-3' : localStorage.systemId
/**
 * 一、功能：
 * 1. 统一设置请求前缀
 * 2. 判断当前是否有region List, 如果没有添加一层请求
 *
 * 二、引包：
 * |-- axios：http 请求工具库
 */

const instance = axios.create({
  // timeout: 10000,
  withCredentials: true,
  headers: {
    // 'X-KSC-REQUEST-ID': uuidv4(),
    // 'X-KSC-REGION': chosedRegion,
    'X-KSC-ACCOUNT-ID': localStorage.userId,
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})
const loadingItem = document.getElementById('monitor-loading')

const requestList = []

// 请求拦截
instance.interceptors.request.use(
  function (config: IAxiosRequestConfig) {
    if (config.url.length > 0) {
      if (!config?.noloading) {
        loadingItem.style.visibility = 'visible'
        const loadings = document.getElementsByClassName('monitor-loading')
        if (loadings?.length) {
          for (let i = 0; i < loadings.length; i++) {
            ;(loadings[i] as HTMLElement).style.visibility = 'visible'
          }
        }
      }
    }
    requestList.push(config.url)
    return config
  },
  function (error) {
    loadingItem.style.visibility = 'hidden'
    const loadings = document.getElementsByClassName('monitor-loading')
    if (loadings?.length) {
      for (let i = 0; i < loadings.length; i++) {
        ;(loadings[i] as HTMLElement).style.visibility = 'hidden'
      }
    }
    return Promise.reject(error)
  }
)
// 响应拦截
instance.interceptors.response.use(
  function (response: IRresponseConfig) {
    const { url } = response.config
    const index = requestList.findIndex(item => item === url)
    requestList.splice(index, 1)
    if (!requestList.length) {
      loadingItem.style.visibility = 'hidden'
      const loadings = document.getElementsByClassName('monitor-loading')
      if (loadings?.length) {
        for (let i = 0; i < loadings.length; i++) {
          ;(loadings[i] as HTMLElement).style.visibility = 'hidden'
        }
      }
    }
    // status 为返回状态的情况
    if (response.data?.status === 0) {
      response.data.code = 'Success'
    }
    const resData = response.data
    // 生成返回data，不包含code & message
    const delKey = ['code', 'message', 'requestId', 'status', 'msg']
    const dataKey = Object.keys(resData).filter(key => !delKey.includes(key))
    const backData = {}
    dataKey.forEach(key => {
      backData[key] = resData[key]
    })
    // const backData = _.cloneDeep(resData)
    // delete backData?.code
    // delete backData?.message
    // delete backData?.requestId
    // delete backData?.status
    // delete backData?.msg
    if (resData?.totalCount && resData?.data) {
      // backData.data['totalCount'] = resData?.totalCount
    }
    // cm 自定义监控接口，返回格式与UIC不同
    if (url.indexOf('/cm/') > -1) {
      return {
        code: 'Success',
        message: '请求成功',
        data: resData?.data ? resData.data : { ...resData }
      }
    }
    if (resData?.Error) {
      return {
        code: resData?.Error?.Code || resData?.Error?.code,
        data: { ...backData },
        message: resData?.Error?.Message || resData?.Error?.message
      }
    }
    if (resData?.code || resData?.message) {
      return {
        code: resData?.code,
        message: resData?.message || resData?.msg,
        data: { ...backData }
      }
    }
    // 获取项目list：没有返回code
    if (url.indexOf('Action=GetAccountAllProjectList') > -1) {
      if (resData?.ListProjectResult?.ProjectList?.length) {
        return {
          code: 'Success',
          message: '请求成功',
          data: {
            ...resData
          }
        }
      } else {
        return {
          code: 'Error',
          message: resData?.Error?.Message || resData?.Error?.message
        }
      }
    }
    return {
      code: resData?.code || resData?.status,
      message: resData?.message || resData?.error || resData?.msg,
      data: { ...backData }
    }
  },
  function (error) {
    const { status, data, config } = error?.response || {}
    // 根据状态码提示错误信息
    if (status) {
      if (data?.error?.message) {
        if (!hideErrorMessageUrl.includes(config.url)) {
          Message.error(`${status}：${_$(data?.error?.message)}`)
        }
      } else {
        codeMessage[status] && Message.error(_$(codeMessage[status]))
      }
    }
    const index = requestList.findIndex(item => item === error)
    requestList.splice(index, 1)
    window.parent.postMessage(
      {
        requestLoading: false
      },
      '*'
    )
    loadingItem.style.visibility = 'hidden'
    return error
  }
)

// 获取region list
const _preRequest = async requestId => {
  const regionData = await instance({
    url: '/monitor/?Action=DescribeMonitorRegions&Version=2021-01-01',
    method: 'GET'
  })
  return regionData?.data?.data || []
}

async function request(url, opts) {
  let options = opts
  if (_.isPlainObject(url)) {
    options = Object.assign({ method: 'get' }, url, options)
  } else if (_.isString(url)) {
    options = {
      method: 'get',
      url: url as string,
      ...options
    }
  } else {
    return Promise.reject({
      code: 406,
      data: null,
      message: '请求参数错误！~'
    })
  }
  const { headers = {}, ...rest } = options
  if (['get', 'GET'].includes(options.method)) {
    _.set(rest, 'params', { ...options.data, timer: new Date().getTime() } || {})
  } else {
    if (Array.isArray(options.data)) {
      _.set(rest, 'data', options.data)
    } else {
      _.set(rest, 'data', { ...options.data, timer: new Date().getTime() } || {})
    }
  }
  // requestID
  _.set(rest, 'headers', { 'X-KSC-REQUEST-ID': uuidv4(), ...headers })
  // 获取浏览器缓存的region
  const region = options.region || localStorage.systemId
  // 判断是否存在，如果存在直接发起请求
  if (region && region !== null && region !== 'null') {
    // 处理 headers
    _.set(rest, 'headers', { 'X-KSC-REGION': region, ...rest.headers })
  } else {
    const monitorRegionList = await _preRequest(uuidv4())
    _processRegion(monitorRegionList)
    _.set(rest, 'headers', { 'X-KSC-REGION': localStorage.systemId, ...rest.headers })
  }
  const result: IRresponseConfig = await instance(rest)
  // 根据请求错误信息处理 && querydata不提示
  if (
    result?.code &&
    result?.code !== 'Success' &&
    !url.includes('/monitorapi/v2/dashboard/querydata')
  ) {
    const errorMessage = interfaceMessage(result?.code)
    if (!errorMessage) {
      Message.warning(result?.message || _$('请求并未返回code或错误信息～'))
    } else {
      Message.error(errorMessage)
    }
    return {
      code: 'error',
      message: errorMessage,
      data: {}
    }
  }
  return result
}
export default request
